import type { Maybe, ShopState } from 'graphql-ts-types';

import { OTHER_REQUEST_REASON } from '../../../contact-form/constants';
import { Locale } from '../../enums/Locale';
import { getQueryParamsString } from '../../utils/url';

export enum CtaType {
  ViewProducts = 'viewProducts',
  ContactSeller = 'contactSeller',
}

export interface SellerContactParams {
  sellerName: string;
  orderId: string;
  shopState: Maybe<ShopState>;
}

export const isContactSellerMode = (ctaType: CtaType) => ctaType === CtaType.ContactSeller;

// To-do this mapping should be removed and the values should be fetched from the backend
export const LOCALE_SHOP_URL: Record<Locale, string> = {
  [Locale.De_De_H24]: 'sortiment',
  [Locale.De_At]: 'sortiment',
  [Locale.De_Ch]: 'sortiment',
  [Locale.Fr_Be]: 'assortiment',
  [Locale.Fr_Ch]: 'assortiment',
  [Locale.Fr_Fr]: 'assortiment',
  [Locale.It_It]: 'assortimento',
  [Locale.Nl_Be]: 'alle-producten',
  [Locale.Nl_Nl]: 'assortiment',
};

export const getShopHref = (locale: Locale, name?: string) =>
  `/${LOCALE_SHOP_URL[locale]}/?shop=${name || 'home24 SE'}`;

export const getContactSellerHref = ({ sellerName, orderId }: SellerContactParams) => {
  const params = { reason: OTHER_REQUEST_REASON, sellerName, orderId };

  return `/contact?${getQueryParamsString(params)}`;
};
